var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('span',{staticClass:"trend-badge",class:_vm.pct >= 0 ? 'up' : 'down'},[_vm._v(" "+_vm._s(_vm.pct >= 0 ? "▲ +" : "▼ ")+_vm._s(Math.abs(_vm.pct).toFixed(1))+"%"),(_vm.label)?[_vm._v(" "+_vm._s(_vm.label))]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }